import React, { FC, ReactNode } from 'react'
import 'react-loading-skeleton/dist/skeleton.css'

interface SkeletonWrapperProps {
  children: ReactNode
}

const SkeletonWrapper: FC<SkeletonWrapperProps> = ({ children }) => {
  return <div>{children}</div>
}

export default SkeletonWrapper
